<div class="Input Superinput">
    <input type="text" ref="input" :placeholder="placeholder" :value="pValue" @blur="onBlur" @input="onInput" @keyup="onKeyUp" />
    <input type="image" src="tivigi/img/remove.svg" alt="Eingabe löschen" title="Eingabe löschen" @click="onClearButtonClick"/>
</div>
